"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _accumoli = _interopRequireDefault(require("./12_group_2022_09_01/accumoli"));

var _agerola = _interopRequireDefault(require("./12_group_2022_09_01/agerola"));

var _albaAdriatica = _interopRequireDefault(require("./12_group_2022_09_01/alba-adriatica"));

var _albavilla = _interopRequireDefault(require("./12_group_2022_09_01/albavilla"));

var _almennoSanSalvatore = _interopRequireDefault(require("./12_group_2022_09_01/almenno-san-salvatore"));

var _appignanoDelTronto = _interopRequireDefault(require("./12_group_2022_09_01/appignano-del-tronto"));

var _arsoli = _interopRequireDefault(require("./12_group_2022_09_01/arsoli"));

var _attigliano = _interopRequireDefault(require("./12_group_2022_09_01/attigliano"));

var _attimis = _interopRequireDefault(require("./12_group_2022_09_01/attimis"));

var _barbara = _interopRequireDefault(require("./12_group_2022_09_01/barbara"));

var _bastiglia = _interopRequireDefault(require("./12_group_2022_09_01/bastiglia"));

var _besenello = _interopRequireDefault(require("./12_group_2022_09_01/besenello"));

var _boffaloraSopraTicino = _interopRequireDefault(require("./12_group_2022_09_01/boffalora-sopra-ticino"));

var _boretto = _interopRequireDefault(require("./12_group_2022_09_01/boretto"));

var _bormio = _interopRequireDefault(require("./12_group_2022_09_01/bormio"));

var _botricello = _interopRequireDefault(require("./12_group_2022_09_01/botricello"));

var _bovezzo = _interopRequireDefault(require("./12_group_2022_09_01/bovezzo"));

var _brenzoneSulGarda = _interopRequireDefault(require("./12_group_2022_09_01/brenzone-sul-garda"));

var _brunello = _interopRequireDefault(require("./12_group_2022_09_01/brunello"));

var _camporotondoDiFiastrone = _interopRequireDefault(require("./12_group_2022_09_01/camporotondo-di-fiastrone"));

var _cappellaMaggiore = _interopRequireDefault(require("./12_group_2022_09_01/cappella-maggiore"));

var _capri = _interopRequireDefault(require("./12_group_2022_09_01/capri"));

var _caprianoDelColle = _interopRequireDefault(require("./12_group_2022_09_01/capriano-del-colle"));

var _caprivaDelFriuli = _interopRequireDefault(require("./12_group_2022_09_01/capriva-del-friuli"));

var _carobbioDegliAngeli = _interopRequireDefault(require("./12_group_2022_09_01/carobbio-degli-angeli"));

var _carpegna = _interopRequireDefault(require("./12_group_2022_09_01/carpegna"));

var _casaluce = _interopRequireDefault(require("./12_group_2022_09_01/casaluce"));

var _casarile = _interopRequireDefault(require("./12_group_2022_09_01/casarile"));

var _cassagoBrianza = _interopRequireDefault(require("./12_group_2022_09_01/cassago-brianza"));

var _castegnato = _interopRequireDefault(require("./12_group_2022_09_01/castegnato"));

var _castelMella = _interopRequireDefault(require("./12_group_2022_09_01/castel-mella"));

var _castionsDiStrada = _interopRequireDefault(require("./12_group_2022_09_01/castions-di-strada"));

var _cavareno = _interopRequireDefault(require("./12_group_2022_09_01/cavareno"));

var _ceggia = _interopRequireDefault(require("./12_group_2022_09_01/ceggia"));

var _cernobbio = _interopRequireDefault(require("./12_group_2022_09_01/cernobbio"));

var _ciserano = _interopRequireDefault(require("./12_group_2022_09_01/ciserano"));

var _cogolloDelCengio = _interopRequireDefault(require("./12_group_2022_09_01/cogollo-del-cengio"));

var _cologne = _interopRequireDefault(require("./12_group_2022_09_01/cologne"));

var _comezzanoCizzago = _interopRequireDefault(require("./12_group_2022_09_01/comezzano-cizzago"));

var _corbola = _interopRequireDefault(require("./12_group_2022_09_01/corbola"));

var _creazzo = _interopRequireDefault(require("./12_group_2022_09_01/creazzo"));

var _falcianoDelMassico = _interopRequireDefault(require("./12_group_2022_09_01/falciano-del-massico"));

var _fiessoUmbertiano = _interopRequireDefault(require("./12_group_2022_09_01/fiesso-umbertiano"));

var _fiuggi = _interopRequireDefault(require("./12_group_2022_09_01/fiuggi"));

var _fiumefreddoDiSicilia = _interopRequireDefault(require("./12_group_2022_09_01/fiumefreddo-di-sicilia"));

var _gaeta = _interopRequireDefault(require("./12_group_2022_09_01/gaeta"));

var _gerenzano = _interopRequireDefault(require("./12_group_2022_09_01/gerenzano"));

var _gorlaMaggiore = _interopRequireDefault(require("./12_group_2022_09_01/gorla-maggiore"));

var _gorlaMinore = _interopRequireDefault(require("./12_group_2022_09_01/gorla-minore"));

var _jeragoConOrago = _interopRequireDefault(require("./12_group_2022_09_01/jerago-con-orago"));

var _laghi = _interopRequireDefault(require("./12_group_2022_09_01/laghi"));

var _lanzada = _interopRequireDefault(require("./12_group_2022_09_01/lanzada"));

var _lierna = _interopRequireDefault(require("./12_group_2022_09_01/lierna"));

var _maccastorna = _interopRequireDefault(require("./12_group_2022_09_01/maccastorna"));

var _macerataCampania = _interopRequireDefault(require("./12_group_2022_09_01/macerata-campania"));

var _magasa = _interopRequireDefault(require("./12_group_2022_09_01/magasa"));

var _magenta = _interopRequireDefault(require("./12_group_2022_09_01/magenta"));

var _malvicino = _interopRequireDefault(require("./12_group_2022_09_01/malvicino"));

var _marigliano = _interopRequireDefault(require("./12_group_2022_09_01/marigliano"));

var _massaLombarda = _interopRequireDefault(require("./12_group_2022_09_01/massa-lombarda"));

var _medolago = _interopRequireDefault(require("./12_group_2022_09_01/medolago"));

var _micigliano = _interopRequireDefault(require("./12_group_2022_09_01/micigliano"));

var _moioDellaCivitella = _interopRequireDefault(require("./12_group_2022_09_01/moio-della-civitella"));

var _monfumo = _interopRequireDefault(require("./12_group_2022_09_01/monfumo"));

var _moricone = _interopRequireDefault(require("./12_group_2022_09_01/moricone"));

var _mozzo = _interopRequireDefault(require("./12_group_2022_09_01/mozzo"));

var _nereto = _interopRequireDefault(require("./12_group_2022_09_01/nereto"));

var _nuvolera = _interopRequireDefault(require("./12_group_2022_09_01/nuvolera"));

var _oltressendaAlta = _interopRequireDefault(require("./12_group_2022_09_01/oltressenda-alta"));

var _paluDelFersina = _interopRequireDefault(require("./12_group_2022_09_01/palu-del-fersina"));

var _pescate = _interopRequireDefault(require("./12_group_2022_09_01/pescate"));

var _petraliaSottana = _interopRequireDefault(require("./12_group_2022_09_01/petralia-sottana"));

var _poggioSanMarcello = _interopRequireDefault(require("./12_group_2022_09_01/poggio-san-marcello"));

var _pognanaLario = _interopRequireDefault(require("./12_group_2022_09_01/pognana-lario"));

var _poncarale = _interopRequireDefault(require("./12_group_2022_09_01/poncarale"));

var _ponteNossa = _interopRequireDefault(require("./12_group_2022_09_01/ponte-nossa"));

var _pradalunga = _interopRequireDefault(require("./12_group_2022_09_01/pradalunga"));

var _procida = _interopRequireDefault(require("./12_group_2022_09_01/procida"));

var _rezzato = _interopRequireDefault(require("./12_group_2022_09_01/rezzato"));

var _robbiate = _interopRequireDefault(require("./12_group_2022_09_01/robbiate"));

var _roccaforteDelGreco = _interopRequireDefault(require("./12_group_2022_09_01/roccaforte-del-greco"));

var _roccaverano = _interopRequireDefault(require("./12_group_2022_09_01/roccaverano"));

var _rolo = _interopRequireDefault(require("./12_group_2022_09_01/rolo"));

var _rossanoVeneto = _interopRequireDefault(require("./12_group_2022_09_01/rossano-veneto"));

var _santAngeloInVado = _interopRequireDefault(require("./12_group_2022_09_01/sant-angelo-in-vado"));

var _santaMariaAVico = _interopRequireDefault(require("./12_group_2022_09_01/santa-maria-a-vico"));

var _santaMariaHoe = _interopRequireDefault(require("./12_group_2022_09_01/santa-maria-hoe"));

var _scido = _interopRequireDefault(require("./12_group_2022_09_01/scido"));

var _selvaDiValGardena = _interopRequireDefault(require("./12_group_2022_09_01/selva-di-val-gardena"));

var _soianoDelLago = _interopRequireDefault(require("./12_group_2022_09_01/soiano-del-lago"));

var _solbiateOlona = _interopRequireDefault(require("./12_group_2022_09_01/solbiate-olona"));

var _spiazzo = _interopRequireDefault(require("./12_group_2022_09_01/spiazzo"));

var _taino = _interopRequireDefault(require("./12_group_2022_09_01/taino"));

var _talmassons = _interopRequireDefault(require("./12_group_2022_09_01/talmassons"));

var _tenna = _interopRequireDefault(require("./12_group_2022_09_01/tenna"));

var _terento = _interopRequireDefault(require("./12_group_2022_09_01/terento"));

var _torboleCasaglia = _interopRequireDefault(require("./12_group_2022_09_01/torbole-casaglia"));

var _vadena = _interopRequireDefault(require("./12_group_2022_09_01/vadena"));

var _veduggioConColzano = _interopRequireDefault(require("./12_group_2022_09_01/veduggio-con-colzano"));

var _vertemateConMinoprio = _interopRequireDefault(require("./12_group_2022_09_01/vertemate-con-minoprio"));

var _vidor = _interopRequireDefault(require("./12_group_2022_09_01/vidor"));

var _villaCarcina = _interopRequireDefault(require("./12_group_2022_09_01/villa-carcina"));

var _villaEstense = _interopRequireDefault(require("./12_group_2022_09_01/villa-estense"));

var _villadose = _interopRequireDefault(require("./12_group_2022_09_01/villadose"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _accumoli["default"], {}, _agerola["default"], {}, _albaAdriatica["default"], {}, _albavilla["default"], {}, _almennoSanSalvatore["default"], {}, _appignanoDelTronto["default"], {}, _arsoli["default"], {}, _attigliano["default"], {}, _attimis["default"], {}, _barbara["default"], {}, _bastiglia["default"], {}, _besenello["default"], {}, _boffaloraSopraTicino["default"], {}, _boretto["default"], {}, _bormio["default"], {}, _botricello["default"], {}, _bovezzo["default"], {}, _brenzoneSulGarda["default"], {}, _brunello["default"], {}, _camporotondoDiFiastrone["default"], {}, _cappellaMaggiore["default"], {}, _capri["default"], {}, _caprianoDelColle["default"], {}, _caprivaDelFriuli["default"], {}, _carobbioDegliAngeli["default"], {}, _carpegna["default"], {}, _casaluce["default"], {}, _casarile["default"], {}, _cassagoBrianza["default"], {}, _castegnato["default"], {}, _castelMella["default"], {}, _castionsDiStrada["default"], {}, _cavareno["default"], {}, _ceggia["default"], {}, _cernobbio["default"], {}, _ciserano["default"], {}, _cogolloDelCengio["default"], {}, _cologne["default"], {}, _comezzanoCizzago["default"], {}, _corbola["default"], {}, _creazzo["default"], {}, _falcianoDelMassico["default"], {}, _fiessoUmbertiano["default"], {}, _fiuggi["default"], {}, _fiumefreddoDiSicilia["default"], {}, _gaeta["default"], {}, _gerenzano["default"], {}, _gorlaMaggiore["default"], {}, _gorlaMinore["default"], {}, _jeragoConOrago["default"], {}, _laghi["default"], {}, _lanzada["default"], {}, _lierna["default"], {}, _maccastorna["default"], {}, _macerataCampania["default"], {}, _magasa["default"], {}, _magenta["default"], {}, _malvicino["default"], {}, _marigliano["default"], {}, _massaLombarda["default"], {}, _medolago["default"], {}, _micigliano["default"], {}, _moioDellaCivitella["default"], {}, _monfumo["default"], {}, _moricone["default"], {}, _mozzo["default"], {}, _nereto["default"], {}, _nuvolera["default"], {}, _oltressendaAlta["default"], {}, _paluDelFersina["default"], {}, _pescate["default"], {}, _petraliaSottana["default"], {}, _poggioSanMarcello["default"], {}, _pognanaLario["default"], {}, _poncarale["default"], {}, _ponteNossa["default"], {}, _pradalunga["default"], {}, _procida["default"], {}, _rezzato["default"], {}, _robbiate["default"], {}, _roccaforteDelGreco["default"], {}, _roccaverano["default"], {}, _rolo["default"], {}, _rossanoVeneto["default"], {}, _santAngeloInVado["default"], {}, _santaMariaAVico["default"], {}, _santaMariaHoe["default"], {}, _scido["default"], {}, _selvaDiValGardena["default"], {}, _soianoDelLago["default"], {}, _solbiateOlona["default"], {}, _spiazzo["default"], {}, _taino["default"], {}, _talmassons["default"], {}, _tenna["default"], {}, _terento["default"], {}, _torboleCasaglia["default"], {}, _vadena["default"], {}, _veduggioConColzano["default"], {}, _vertemateConMinoprio["default"], {}, _vidor["default"], {}, _villaCarcina["default"], {}, _villaEstense["default"], {}, _villadose["default"]);

exports["default"] = _default;